
window.__lazy_callback__ = function (lazyModule) {
  return class extends React.Component {
    state = {
      component: null,
    }
    componentWillMount() {
      lazyModule((module) => {
        if (typeof module.default === 'function') {
          this.setState({
            component: module.default,
          });
        } else {
          this.setState({
            component: module,
          });
        }
      });
    }
    render() {
      const Comp = this.state.component;
      return Comp ? <Comp {...this.props} /> : <div />;
    }
  };
}

import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux'
import Loadimg from './loadimg'

const mapStateToProps = state => ({
  loadingPop: state.loadingPop
})

const mapDispatchToProps = dispatch => ({})

class AllLoading extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.loadingPop === this.props.loadingPop) {
      return false
    } else {
      return true
    }
  }
  render() {
    const { loadingPop } = this.props
    return (
      <Fragment>
        {
          loadingPop === true
          ?
          <div className="AllLoading">
            <div className="loading-content">
              <div className="loading-box">
                <div className="loading">
                  <Loadimg />
                </div>
              </div>
              <h5>加载中...</h5>
            </div>
          </div>
          :
          ''
        }
      </Fragment>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AllLoading);